import * as React from 'react'
import { CurrentFormikContext } from '../context/CurrentFormikContext'

export function useCurrentFormik() {
  return React.useContext(CurrentFormikContext)
}
